<template>
    <el-dialog title="Клонирование заявки" :visible.sync="visibleModalModel" width="350px" :append-to-body="true">
        <div v-loading="loading">
            <div class="form-group row mb-1">
                <label for="last_name" class="col-sm-4 col-form-label">Фамилия</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="last_name" v-model="last_name" :class="{ 'is-invalid': form.errors.has('last_name') }">
                    <has-error :form="form" field="last_name"/>
                </div>
            </div>
            <div class="form-group row mb-1">
                <label for="first_name" class="col-sm-4 col-form-label">Имя</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="first_name" v-model="first_name" :class="{ 'is-invalid': form.errors.has('first_name') }">
                    <has-error :form="form" field="first_name"/>
                </div>
            </div>
            <div class="form-group row mb-1">
                <label for="middle_name" class="col-sm-4 col-form-label">Отчество</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="middle_name" v-model="middle_name" :class="{ 'is-invalid': form.errors.has('middle_name') }">
                    <has-error :form="form" field="middle_name"/>
                </div>
            </div>
            <div class="form-group row mb-1">
                <label for="phone" class="col-sm-4 col-form-label">Телефон</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="phone" v-model="phone" :class="{ 'is-invalid': form.errors.has('phone') }" v-mask="{mask: '+7 (999) 999-99-99', clearIncomplete: true}">
                    <has-error :form="form" field="phone"/>
                </div>
            </div>
            <div class="form-group text-center mb-0 mt-3">
                <button :disabled="form.busy" class="btn btn-primary btn-lg" @click="create">Клонировать</button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import Form from "vform";
    import toastr from "toastr";

    export default {
        name: "ModalRequestClone",
        props: ['visibleModalRequestClone', 'request'],
        data: () => ({
            first_name: null,
            last_name: null,
            middle_name: null,
            phone: null,
            status: "arrived",

            form: new Form(),
            loading: false,
        }),
        computed: {
            visibleModalModel: {
                get () { return this.visibleModalRequestClone },
                set (value) { this.$emit('update:visibleModalRequestClone', value) },
            },
        },
        methods: {
            create() {
                let self = this;
                if (this.validateForm()) {
                    this.loading = true;
                    axios.get('/api/requests/findByPhone/' + this.form.phone)
                        .then(function (response) {
                            if (!!response.data) {
                                self.$allowRequest(response.data.id)
                                    .then(function () {
                                        toastr.warning('Заявка уже существует');
                                        if (parseInt(self.request.id) !== parseInt(response.data.id)) self.$router.push({name: 'request', params: {id: response.data.id}});
                                        self.loading = false;
                                        self.visibleModalModel = false;
                                    })
                            } else {
                                let request = null;
                                self.form.post('/api/requests/from_salon')
                                    .then(function (response) {
                                        request = response.data;
                                        toastr.success('Заявка создана');
                                        return self.$allowRequest(request.id);
                                    })
                                    .then(function () {
                                        self.$router.push({name: 'request', params: {id: request.id}});
                                        self.loading = false;
                                        self.visibleModalModel = false;
                                    })
                            }
                        });
                }
            },
            validateForm() {
                this.form = new Form();

                let data_save = {};

                if (this.last_name === null || !this.last_name.length) {this.form.errors.set('last_name', ['Введите фамилию']);} else {data_save.last_name = this.last_name.trim();}
                if (this.first_name === null || !this.first_name.length) {this.form.errors.set('first_name', ['Введите имя']);} else {data_save.first_name = this.first_name.trim();}
                if (this.middle_name === null || !this.middle_name.length) {this.form.errors.set('middle_name', ['Введите отчество']);} else {data_save.middle_name = this.middle_name.trim();}
                if (!this.validatePhone(this.preparePhone(this.phone))) {this.form.errors.set('phone', ['Введите телефон']);} else {data_save.phone = this.preparePhone(this.phone);}

                data_save.status = (this.status) ? this.status : 'new';
                // data_save.visit_date = moment().format('YYYY-MM-DD HH:mm:00');
                data_save.operator_id = this.request.operator_id;
                data_save.sales_manager_id = this.request.sales_manager_id;
                data_save.credit_manager_id = this.request.credit_manager_id;
                data_save.source_id = this.request.source_id;
                data_save.platform_id = this.request.platform_id;
                data_save.utm_source = this.request.utm_source;
                data_save.utm_medium = this.request.utm_medium;
                data_save.utm_campaign = this.request.utm_campaign;
                data_save.utm_term = this.request.utm_term;
                data_save.utm_content = this.request.utm_content;
                data_save.referer = this.request.referer;

                let user = this.$store.getters['auth/user'];
                if (user) {
                    if (this.$hasRole('operator')) data_save.operator_id = user.id;
                    if (this.$hasRole('sales_manager')) data_save.sales_manager_id = user.id;
                    if (this.$hasRole('credit_manager')) data_save.credit_manager_id = user.id;
                }


                if (this.form.errors.any()) {
                    return false;
                } else {
                    this.form = new Form(data_save);
                    return true;
                }
            },
            preparePhone (p) {
                return p === null ? '' : p.replace(/[^\+0-9]/g, '');
            },
            validatePhone (p) {
                return p.slice(0,2) === '+7' && p.length === 12;
            },
        },
    }
</script>

<style scoped>

</style>
